import { SmartMeterGatewayPostRequestDto } from '../api/dto/smart-meter-gateway.dto'

export interface SmartMeterGatewayFormModel {
  isEebusDetectionEnabled: boolean
  isSmartMeterConnected?: boolean
  ski?: string
}

const fromSmartMeterGatewayFormToDtoTransformer = (item: SmartMeterGatewayFormModel): SmartMeterGatewayPostRequestDto => ({
  eebusDetectionState: item.isEebusDetectionEnabled,
})

export default fromSmartMeterGatewayFormToDtoTransformer
